import React from "react";
import './userComponents.css';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CategoryIcon from "@mui/icons-material/Category";
import StraightenIcon from "@mui/icons-material/Straighten";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import ContentCutIcon from '@mui/icons-material/ContentCut';
import { GiClothes, GiSewingMachine } from "react-icons/gi"; 
import { TbIroningSteam } from "react-icons/tb";
import { BiSolidWasher } from "react-icons/bi";
import { MdDryCleaning } from "react-icons/md";

const getServiceIcon = (serviceType) => {
  switch(serviceType) {
    case "DRYCLEANING":
      return <MdDryCleaning className="text-[#3383B2]" size={24} />;
    case "IRONING":
      return <TbIroningSteam className="text-[#3383B2]" size={24} />;
    case "TAILORING":
      return <GiSewingMachine className="text-[#3383B2]" size={24} />;
    case "WASH_N_FOLD":
    case "Wash & Fold":
      return <BiSolidWasher className="text-[#3383B2]" size={24} />;
    default:
      return <BiSolidWasher className="text-[#3383B2]" size={24} />;
  }
};

const ServiceCard = ({ service }) => {
  return (
    <div className="serrvice-card bg-white shadow-md rounded-2xl w-full max-w-3xl mx-auto p-4 hover:shadow-lg transition-all space-y-3">
      
      {/* Header */}
      <div className="flex items-center gap-2 mb-2">
        {getServiceIcon(service?.serviceType)}
        <h2 className="text-lg font-bold text-gray-800">{service?.serviceType}</h2>
      </div>

      {/* unitDetails */}
      {service?.unitDetails?.length > 0 && service.unitDetails.map((item, idx) => (
        <div key={`unit-${item.id || idx}`} className="border rounded-xl p-3 bg-[#F0F6FA] space-y-1">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2 text-[#3383B2]">
              <GiClothes size={16} />
              <span className="capitalize font-medium text-gray-700">{item?.cloth_name ?? "Cloth"}</span>
            </div>
            <div className="flex items-center text-[#1B9C85] font-semibold">
              <AttachMoneyIcon fontSize="small" />
              {item?.tailoringType?.price ?? item?.price ?? "N/A"}
            </div>
          </div>
          <div className="text-xs text-gray-500">{item?.description ?? "No description"}</div>
          <div className="flex flex-wrap gap-2 mt-1 text-xs">
            <div className="flex items-center gap-1 bg-[#E4F1F9] text-[#3383B2] px-2 py-0.5 rounded-full shadow-sm">
              <CategoryIcon fontSize="small" />
              <span className="capitalize">{item?.category ?? "N/A"}</span>
            </div>
            {item?.tailoringType?.name && (
              <div className="flex items-center gap-1 bg-[#EDE7F6] text-[#6A1B9A] px-2 py-0.5 rounded-full shadow-sm">
                <ContentCutIcon fontSize="small" />
                <span className="capitalize">{item.tailoringType.name}</span>
              </div>
            )}
            <div className="flex items-center gap-1 bg-[#FFF3E0] text-[#FB8C00] px-2 py-0.5 rounded-full shadow-sm">
              <FlashOnIcon fontSize="small" />
              <span>Per Piece</span>
            </div>
          </div>
        </div>
      ))}

      {/* poundDetails */}
      {service?.poundDetails?.length > 0 && service.poundDetails.map((item, idx) => (
        <div key={`pound-${item.id || idx}`} className="border rounded-xl p-3 bg-[#F0F6FA] space-y-1">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2 text-[#3383B2]">
              <StraightenIcon fontSize="small" />
              <span className="capitalize font-medium text-gray-700">{item?.quantity} lbs</span>
            </div>
            <div className="flex items-center text-[#1B9C85] font-semibold">
              <AttachMoneyIcon fontSize="small" />
              {item?.price ?? "N/A"}
            </div>
          </div>
          <div className="text-xs text-gray-500">{item?.description ?? "No description"}</div>
          <div className="flex flex-wrap gap-2 mt-1 text-xs">
            <div className="flex items-center gap-1 bg-[#E4F1F9] text-[#3383B2] px-2 py-0.5 rounded-full shadow-sm">
              <CategoryIcon fontSize="small" />
              <span className="capitalize">{item?.category ?? "N/A"}</span>
            </div>
            <div className="flex items-center gap-1 bg-[#FFF3E0] text-[#FB8C00] px-2 py-0.5 rounded-full shadow-sm">
              <FlashOnIcon fontSize="small" />
              <span>Pound</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceCard;
